"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = require("react-dom");
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _configContext = require("../context/config-context");
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-c7cdqn3"
});
const FlexContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FlexContainer",
  class: "pc-fv5z8xc"
});
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentContainer",
  class: "pc-c6i4c0l"
});
const PriceContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PriceContainer",
  class: "pc-p552qa1"
});
const AnchorContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AnchorContainer",
  class: "pc-a4gnlt9"
});
const TotalContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TotalContent",
  class: "pc-tjpyrnu"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pc-bttvieh"
});

/**
 * FixedCheckout Component.
 *
 * @param {Object} props React props
 * @param {Object} props.checkoutCta The checkout button configuration
 * @param {string} props.title The title of the checkout item
 * @param {string} props.description The description of the checkout item
 * @param {string} props.subTotal The subtotal of the checkout item
 * @param {boolean} props.parentVisible Flag indicating if the parent component is visible
 * @param {Object} props.scrollRef Reference to the scroll element
 * @param {function} props.handleFixedClick Callback function for handling click events
 * @param {string} props.partialTheme Partial Theme
 * @returns {React.ReactElement} FixedCheckout Component
 * @public
 */

function FixedCheckout({
  checkoutCta,
  title,
  description,
  subTotal,
  parentVisible,
  scrollRef,
  handleFixedClick,
  partialTheme = 'bluectas'
}) {
  const containerRef = (0, _react.useRef)(null);
  const {
    asModal
  } = (0, _configContext.useConfig)();
  const scrollButtonTracking = _tracking.default.create('fixed-checkout-scroll-to-summary', true, false);
  (0, _react.useEffect)(() => {
    if (parentVisible) {
      containerRef.current.style.transform = 'translateY(100%)';
    } else {
      if (asModal) {
        containerRef.current.style.zIndex = '2001'; // 1 level above modal
      }
      containerRef.current.style.transform = 'translateY(0)';
    }
  }, [parentVisible]);
  const scrollToRef = () => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const fixedCheckoutContent = /*#__PURE__*/_react.default.createElement(Container, {
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(FlexContainer, null, /*#__PURE__*/_react.default.createElement(ContentContainer, null, /*#__PURE__*/_react.default.createElement(TotalContent, null, /*#__PURE__*/_react.default.createElement(PriceContainer, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    className: "subtotal",
    as: "title",
    text: `${title}:`,
    size: 0
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    className: "subtotal",
    as: "paragraph",
    text: subTotal,
    size: 0
  })), /*#__PURE__*/_react.default.createElement(AnchorContainer, null, /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    "aria-label": `Scroll to ${description}`,
    onTouchStart: scrollToRef
  }, scrollButtonTracking, {
    "data-cy": "fixed-checkout-scroll-button"
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    className: "subtotal",
    as: "caption",
    text: description,
    size: -1
  }))))), /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    'data-partial': partialTheme
  }, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButtonSet, {
    buttons: [checkoutCta],
    onClick: handleFixedClick
  }))));

  // If inside a modal, render using portal to body (not modal content) since this is fixed positioned
  if (asModal) {
    return /*#__PURE__*/(0, _reactDom.createPortal)(fixedCheckoutContent, document.body);
  }

  // Default rendering for non-modal scenarios
  return fixedCheckoutContent;
}
var _default = exports.default = FixedCheckout;
FixedCheckout.propTypes = {
  checkoutCta: _propTypes.default.object,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  subTotal: _propTypes.default.string,
  parentVisible: _propTypes.default.bool,
  scrollRef: _propTypes.default.object,
  handleFixedClick: _propTypes.default.func,
  partialTheme: _propTypes.default.string
};